<template>
  <div>
    <div class="newsList oa-layout-content">
      <!--公文简报 -->
      <div>
        <div class="newsLsit-header">
          <a-tabs :default-active-key="tobIt" @change="callback">
            <a-tab-pane key="1" tab="待办任务" v-if="isHomePage(1)" />
            <a-tab-pane key="2" tab="已办任务" v-if="isHomePage(2)" />
            <a-tab-pane key="3" tab="我的申请" v-if="isHomePage(3)" />
            <a-tab-pane key="4" tab="公文" v-if="isHomePage(4)" />
            <a-tab-pane key="5" tab="简报" v-if="isHomePage(5)" />
            <a-tab-pane key="6" tab="公司新闻" v-if="isHomePage(6)" />
            <a-tab-pane key="7" tab="我的整改任务" v-if="isHomePage(7)" />
          </a-tabs>
          <!-- v-if="tobIt == 2 || tobIt == 6" -->
          <a-input-search
            v-if="isSearch"
            allowClear
            class="newsLsit-search"
            placeholder="请输入搜索内容"
            style="width: 300px"
            @search="onSearch"
          />
        </div>
        <div class="a-spin-mask" v-if="aSpinMask">
          <a-spin />
        </div>
        <!-- 待办 已办 我的申请 -->
        <div v-if="tobIt < 4">
          <div
            class="my-mission-item"
            v-for="(need, index) in newsList"
            :key="index"
            @click="goSpl(need.resp)"
          >
            <div>
              <div class="my-mission-tips">
                <span class="state1 mr5" v-if="need.resp.processStatus == 1">
                  审批中
                </span>
                <span class="state2 mr5" v-if="need.resp.processStatus == 2">
                  已办结
                </span>
                [{{ need.appName }}]
                <span class="my-mission-title">
                  {{ need.processName }}
                </span>
              </div>
            </div>

            <span class="my-mission-time">{{
              need.createdDate.substring(0, 10)
            }}</span>
            <!-- 暂无更多数据 -->
          </div>
        </div>
        <!-- 公文简报 -->
        <div v-if="tobIt == 4 || tobIt == 5">
          <div
            class="my-mission-item"
            v-for="(item, i) in newsList"
            :key="i"
            @click="goNewsDetial(item)"
          >
            <div class="my-mission-tips">
              <span
                class="wordbench-unread"
                v-if="item.documentConsultStatus == 2"
                >未查阅</span
              >
              {{ item.title }}
            </div>
            <span class="my-mission-time">{{ item.createTime }}</span>
          </div>
        </div>

        <!-- 新闻 -->
        <div v-if="tobIt == 6">
          <div
            class="newslist-item"
            v-for="(item, i) in newsList.data"
            :key="i"
            @click="goNewsDetial(item)"
          >
            <blank height="15" v-if="i > 1"></blank>
            <div class="newsItem-title">{{ item.title }}</div>

            <blank height="20"></blank>
            <div class="newsItem-bottom">
              <div class="newsItem-name">
                {{ item.source }}/{{ item.editperson }} 发布
              </div>
              <div class="newsItem-time">{{ item.time }}</div>
            </div>
          </div>
        </div>
        <!-- 我的整改任务 -->
        <div v-if="tobIt == 7">
          <div
            class="my-mission-item"
            v-for="(item, i) in newsList"
            :key="i"
            @click="goNewsDetial(item)"
          >
            <div class="my-mission-tips">
              {{ item.giveOrgName }}
              给您发了一条整改任务，请在{{ item.startTime }}-{{
                item.endTime
              }}完成。
            </div>
            <span class="my-mission-time">{{ item.createTime }}</span>
          </div>
        </div>
        <a-empty v-if="newsList.length === 0 ? true : false" />
        <!-- <blank height="82"></blank> -->
        <div class="pagination">
          <a-pagination
            size="small"
            :current="page"
            :pageSize="size"
            :default-current="page"
            :total="total"
            @change="pageChange"
          />
        </div>
      </div>
    </div>
    <appfloor></appfloor>
  </div>
</template>

<script>
import {
  officialDocumentMyOfficialDocument,
  briefingGetBreiefing,
  briefingCreateWord,
  officialDocumentCreateWord,
  projectApplyCreateWord,
  getTheInformationRelease,
  activityProcess
} from '@/views/workbench/api/api'
import { getMyTasks, getMyTasksistory } from '@/http/url'
import { getTask } from '@/views/standingBook/api/api'
export default {
  data() {
    return {
      newsList: {},
      tobIt: 1,
      page: 1,
      size: 10,
      total: 0,
      processName: '',
      HomePageIds: [],
      aSpinMask: true,
      isSearch: false
    }
  },
  created() {
    this.tobIt = this.$route.query.tobIt
    this.gain(this.$route.query.tobIt, { page: this.page, size: this.size })
    this.HomePageIds = this.$store.state.app.HomePageIds
    if (this.tobIt === '1') {
      this.isSearch = true
    }
  },
  methods: {
    // 获取是否存在当前模块
    isHomePage(HomePageId) {
      this.isSearch = true
      return this.HomePageIds.find((item) => {
        return item == HomePageId
      })
    },
    gain(i, obj) {
      this.aSpinMask = true
      if (i == 1) {
        //我的代办
        obj.processName = this.processName
        getMyTasks(obj).then((res) => {
          if (res.data.code === 0) {
            this.aSpinMask = false
            this.newsList = res.data.data
            this.total = res.data.count
          }
        })
        return
      }
      if (i == 2) {
        //我的已办
        obj.processName = this.processName
        getMyTasksistory(obj).then((res) => {
          if (res.data.code === 0) {
            this.aSpinMask = false
            this.newsList = res.data.data
            this.total = res.data.count
          }
        })
        return
      }
      if (i == 3) {
        //我的申请
        obj.processName = this.processName
        activityProcess(obj).then((res) => {
          if (res.data.code === 0) {
            this.aSpinMask = false
            this.newsList = res.data.data
            this.total = res.data.count
          }
        })
        return
      }
      if (i == 4) {
        //公文
        obj.title = this.processName
        officialDocumentMyOfficialDocument(obj).then((res) => {
          if (res.data.code == 0) {
            this.aSpinMask = false
            // console.log(res);
            this.newsList = res.data.data
            this.total = res.data.count
          }
        })
        return
      }
      if (i == 5) {
        // 简报
        obj.title = this.processName
        briefingGetBreiefing(obj).then((res) => {
          if (res.data.code == 0) {
            this.aSpinMask = false
            this.newsList = res.data.data
            this.total = res.data.count
          }
        })
        return
      }
      if (i == 6) {
        // 新闻
        obj.title = this.processName
        getTheInformationRelease(obj).then((res) => {
          if (res.data.code == 0) {
            this.aSpinMask = false
            this.newsList = res.data.data
            this.total = res.data.count
          }
        })
        return
      }
      if (i == 7) {
        // 我的整改任务
        obj.title = this.processName
        getTask(obj).then((res) => {
          if (res.data.code == 0) {
            this.aSpinMask = false
            this.newsList = res.data.data
            this.total = res.data.count
          }
        })
        return
      }
    },
    callback(key) {
      this.page = 1
      this.tobIt = key
      this.processName = ''
      this.gain(this.tobIt, { page: this.page, size: this.size })
    },
    pageChange(pageNumber) {
      this.page = pageNumber
      this.gain(this.tobIt, { page: this.page, size: this.size })
    },
    onSearch(value) {
      this.processName = value
      this.gain(this.tobIt, { size: this.size, page: 1 })
    },

    goSpl(resp) {
      if (this.tobIt == 1) {
        //代办
        this.goDetial(resp)
      } else {
        this.openTask(resp)
      }
    },

    // 去查看 审批流
    openTask(resp) {
      let path = resp.skipPageReqFlag
      let id = resp.businessKey
      let formStep = resp.formStep
      let currentStep = resp.currentStep
      let isEdit = resp.isEdit
      let taskId = resp.taskId
      let processInstanceId = resp.processInstanceId
      let showApproveBtn = 0
      this.$router.push({
        path,
        query: {
          id,
          currentStep,
          formStep,
          isEdit,
          taskId,
          showApproveBtn
        }
      })
    },

    // 去办理 进入审批流
    goDetial(resp) {
      /*
      审批流
        表单可编辑步骤：currentStep    默认100全部表单。1当前是第一步，2当前是第二步
        表单步骤：formStep: 100 全表单 1 代表第一步骤 2 代表第二步骤
        是否可编辑：isEdit: 100和1不可编辑 0 可编辑
        显示审批按钮 showApproveBtn: 1
      */
      let path = resp.skipPageReqFlag
      let id = resp.businessKey
      let formStep = resp.formStep
      let currentStep = resp.currentStep
      let isEdit = resp.isEdit
      let taskId = resp.taskId
      let processInstanceId = resp.processInstanceId
      let showApproveBtn = 1
      const { href } = this.$router.resolve({
        path,
        query: {
          id,
          currentStep,
          formStep,
          isEdit,
          taskId,
          showApproveBtn
        }
      })
      window.open(href, '_self')
    },
    goNewsDetial(i) {
      //新闻
      if (this.tobIt == 6) {
        this.$router.push({
          path: '/newsDetial',
          query: {
            id: i.id
          }
        })
        return
      }
      //我的整改任务
      if (this.tobIt == 7) {
        this.$router.push({
          path: '/standingBookDetails',
          query: {
            auditOrgId: i.giveOrgId,
            auditedOrgId: i.receiveOrgId,
            auditOrgName: i.giveOrgName,
            auditedOrgName: i.receiveOrgName,
            businessId: i.id
          }
        })

        return
      }
      if (this.tobIt == 4) {
        // 公文
        if (i.skipPageReqFlag == '/OfficialDocumentDetial') {
          //公文模块
          officialDocumentCreateWord({ id: i.documentId, workbench: 1 }).then(
            (res) => {
              if (res.data.code == 0) {
                this.aSpinMask = false

                // 查看
                let item = res.data.data
                if (item.fileformat == 'bpmn') {
                  this.$message.error('该文件类型(bpmn)系统暂时不支持在线预览')
                } else {
                  let Base64 = require('js-base64').Base64
                  window.open(
                    item.kkFileUrl +
                      encodeURIComponent(Base64.encode(item.fileUrl))
                  )
                }
              }
            }
          )
        } else if (i.skipPageReqFlag == '/ProjectApplicationDetial') {
          //项目申请模块
          projectApplyCreateWord({ id: i.documentId, workbench: 1 }).then(
            (res) => {
              if (res.data.code == 0) {
                this.aSpinMask = false

                // 查看
                let item = res.data.data
                if (item.fileformat == 'bpmn') {
                  this.$message.error('该文件类型(bpmn)系统暂时不支持在线预览')
                } else {
                  let Base64 = require('js-base64').Base64
                  window.open(
                    item.kkFileUrl +
                      encodeURIComponent(Base64.encode(item.fileUrl))
                  )
                }
              }
            }
          )
        } else if (i.skipPageReqFlag == '/InformTheForwardingDetial') {
          //公文转发模块
          this.$router.push({
            path: '/InformTheForwardingDetial',
            query: {
              id: i.documentId,
              workbench: 1,
              isEdit: 1
            }
          })
        }
        return
      }
      if (this.tobIt == 5) {
        // 简报
        briefingCreateWord({ id: i.documentId, workbench: 1 }).then((res) => {
          if (res.data.code == 0) {
            this.aSpinMask = false
            // 查看
            let item = res.data.data
            if (item.fileformat == 'bpmn') {
              this.$message.error('该文件类型(bpmn)系统暂时不支持在线预览')
            } else {
              let Base64 = require('js-base64').Base64
              window.open(
                item.kkFileUrl + encodeURIComponent(Base64.encode(item.fileUrl))
              )
            }
          }
        })
        return
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.newsList {
  height: auto;
  position: relative;
  .newsLsit-header {
    position: relative;
    .newsLsit-search {
      position: absolute;
      top: 0;
      right: 20px;
    }
  }
  .newslist-item {
    padding: 0 15px 15px 15px;
    border-bottom: #e9e9e9 1px solid;
    cursor: pointer;
    .newsItem-title {
      height: 24px;
      left: 317px;
      top: 220px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 24px;
      text-align: left;
    }
    .newItem-cont {
      width: 678px;
      height: 46px;
      color: rgba(29, 20, 20, 0.65);
      font-size: 14px;
      line-height: 23px;
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .newsItem-bottom {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .newsItem-logo {
        width: 20px;
        height: 20px;
        border-radius: 50%;
      }
      .newsItem-name {
        height: 22px;
        color: rgba(0, 0, 0, 1);
        font-size: 14px;
        line-height: 22px;
      }
      .newsItem-time {
        margin-left: 20px;
        height: 22px;
        color: rgba(0, 0, 0, 0.25);
        font-size: 14px;
        line-height: 22px;
      }
    }
  }
}
.my-mission-item {
  padding: 0 50px 10px 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  justify-content: space-between;
  font-size: 14px;
  cursor: pointer;
  .my-mission-tips {
    // width: 500px;
    height: auto;
    overflow: hidden;
    color: #808080;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .my-mission-time {
    width: 150px;
    text-align: right;
  }
}
.wordbench-unread {
  margin-right: 10px;
  width: 44px;
  height: 21px;
  color: rgba(212, 48, 48, 1);
  background-color: rgba(255, 255, 255, 1);
  border: rgba(212, 48, 48, 1) solid 1px;
  border-radius: 4px;
  font-size: 13px;
  text-align: center;
}
.a-spin-mask {
  position: absolute;
  top: 80px;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 400px;
  overflow: hidden;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background: #fff;
}
</style>

  


// WEBPACK FOOTER //
// src/views/myMission/index.vue